"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var coreutils_1 = require("@phosphor/coreutils");
/* tslint:disable */

/**
 * The default window resolver token.
 */


exports.IWindowResolver = new coreutils_1.Token('@jupyterlab/apputils:IWindowResolver');
/**
 * A concrete implementation of a window name resolver.
 */

var WindowResolver = /*#__PURE__*/function () {
  function WindowResolver() {
    _classCallCheck(this, WindowResolver);

    this._name = null;
  }
  /**
   * The resolved window name.
   */


  _createClass(WindowResolver, [{
    key: "name",
    get: function get() {
      return this._name;
    }
    /**
     * Resolve a window name to use as a handle among shared resources.
     *
     * @param candidate - The potential window name being resolved.
     *
     * #### Notes
     * Typically, the name candidate should be a JupyterLab workspace name or
     * an empty string if there is no workspace.
     *
     * If the returned promise rejects, a window name cannot be resolved without
     * user intervention, which typically means navigation to a new URL.
     */

  }, {
    key: "resolve",
    value: function resolve(candidate) {
      var _this = this;

      return Private.resolve(candidate).then(function (name) {
        _this._name = name;
      });
    }
  }]);

  return WindowResolver;
}();

exports.WindowResolver = WindowResolver;
/*
 * A namespace for private module data.
 */

var Private;

(function (Private) {
  /**
   * The internal prefix for private local storage keys.
   */
  var PREFIX = '@jupyterlab/coreutils:StateDB';
  /**
   * The local storage beacon key.
   */

  var BEACON = "".concat(PREFIX, ":beacon");
  /**
   * The timeout (in ms) to wait for beacon responders.
   *
   * #### Notes
   * This value is a whole number between 200 and 500 in order to prevent
   * perfect timeout collisions between multiple simultaneously opening windows
   * that have the same URL. This is an edge case because multiple windows
   * should not ordinarily share the same URL, but it can be contrived.
   */

  var TIMEOUT = Math.floor(200 + Math.random() * 300);
  /**
   * The local storage window key.
   */

  var WINDOW = "".concat(PREFIX, ":window");
  /**
   * A potential preferred default window name.
   */

  var candidate = null;
  /**
   * The window name promise.
   */

  var delegate = new coreutils_1.PromiseDelegate();
  /**
   * The known window names.
   */

  var known = {};
  /**
   * The window name.
   */

  var name = null;
  /**
   * Whether the name resolution has completed.
   */

  var resolved = false;
  /**
   * Start the storage event handler.
   */

  function initialize() {
    // Listen to all storage events for beacons and window names.
    window.addEventListener('storage', function (event) {
      var key = event.key,
          newValue = event.newValue; // All the keys we care about have values.

      if (newValue === null) {
        return;
      } // If the beacon was fired, respond with a ping.


      if (key === BEACON && candidate !== null) {
        ping(resolved ? name : candidate);
        return;
      } // If the window name is resolved, bail.


      if (resolved || key !== WINDOW) {
        return;
      }

      var reported = newValue.replace(/\-\d+$/, ''); // Store the reported window name.

      known[reported] = null; // If a reported window name and candidate collide, reject the candidate.

      if (candidate in known) {
        reject();
      }
    });
  }
  /**
   * Ping peers with payload.
   */


  function ping(payload) {
    if (payload === null) {
      return;
    }

    var _window = window,
        localStorage = _window.localStorage;
    localStorage.setItem(WINDOW, "".concat(payload, "-").concat(new Date().getTime()));
  }
  /**
   * Reject the candidate.
   */


  function reject() {
    resolved = true;
    delegate.reject("Window name candidate \"".concat(candidate, "\" already exists"));
  }
  /**
   * Returns a promise that resolves with the window name used for restoration.
   */


  function resolve(potential) {
    if (resolved) {
      return delegate.promise;
    } // Set the local candidate.


    candidate = potential;

    if (candidate in known) {
      reject();
      return delegate.promise;
    }

    var _window2 = window,
        localStorage = _window2.localStorage,
        setTimeout = _window2.setTimeout; // Wait until other windows have reported before claiming the candidate.

    setTimeout(function () {
      if (resolved) {
        return;
      } // If the window name has not already been resolved, check one last time
      // to confirm it is not a duplicate before resolving.


      if (candidate in known) {
        return reject();
      }

      resolved = true;
      delegate.resolve(name = candidate);
      ping(name);
    }, TIMEOUT); // Fire the beacon to collect other windows' names.

    localStorage.setItem(BEACON, "".concat(Math.random(), "-").concat(new Date().getTime()));
    return delegate.promise;
  }

  Private.resolve = resolve; // Initialize the storage listener at runtime.

  (function () {
    initialize();
  })();
})(Private || (Private = {}));